<template>
  <BriefStep :title="title">
    <template v-slot:content>
      <div class="brief-form">
        <div class="brief-form">
          <div
            class="
              form__input-wrapper
              form__input-wrapper--check
              form__input-wrapper--check-squer
            "
            v-for="checkbox in formCheckboxes"
            :key="checkbox.name"
          >
            <input
              class=""
              :id="checkbox.name"
              type="checkbox"
              :name="checkbox.name"
              :value="checkbox.value"
              v-model.trim="form.siteStyle"
              @input="invokeTouch($v.form.siteStyle)"
            />
            <label :for="checkbox.name" class="form__label">{{
              checkbox.label
            }}</label>
          </div>
          <div
            class="
              form__input-wrapper
              form__input-wrapper--check
              form__input-wrapper--check-squer
            "
          >
            <input
              class=""
              id="ss-other"
              type="checkbox"
              name="ss-other"
              value="Inne"
              @input="invokeTouch($v.form.siteStyle)"
              @click="otherHandler"
            />
            <label for="ss-other" class="form__label">Inne</label>
          </div>
          <transition name="fade-input">
            <div
              v-if="hasDescription"
              class="form__input-wrapper"
              :class="{ error: $v.form.siteOtherStyles.$anyError }"
            >
              <label for="siteOtherStyles" class="form__label uk-hidden"
                >Podaj inne</label
              >
              <input
                class="form-input uk-width-1-1"
                id="siteOtherStyles"
                type="text"
                name="siteOtherStyles"
                ref="otherInput"
                @input="event => delayTouchCounterComposition($v.form, 'siteOtherStyles', event.target.value)"
              />
              <span class="form__error-message form__error-message--no-label">
                <template v-if="!$v.form.siteOtherStyles.minLength">
                  {{ validationMessage.minLength }}</template
                >
                <template v-if="!$v.form.siteOtherStyles.required">
                  {{ validationMessage.required }}</template
                >
              </span>
            </div>
          </transition>
        </div>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { minLength, required } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';

import BriefStep from '../global/BriefStep.vue';

export default {
  name: 'SiteStyle',
  components: { BriefStep },
  mixins: [stepValidation],
  data: () => ({
    title:
      'Jak cię widzą, tak cię piszą. Określ styl swojej wymarzonej strony.',
    form: {
      siteStyle: [],
      siteOtherStyles: '',
    },
    hasDescription: false,
    formCheckboxes: [
      {
        name: 'ss-minimal',
        value: 'minimalistyczna',
        label: 'minimalistyczna',
      },
      {
        name: 'ss-elegant',
        value: 'elegancka',
        label: 'elegancka',
      },
      {
        name: 'ss-serious',
        value: 'poważna',
        label: 'poważna',
      },
      {
        name: 'ss-subtle',
        value: 'subtelna',
        label: 'subtelna',
      },
      {
        name: 'ss-happy',
        value: 'wesoła',
        label: 'wesoła',
      },
    ],
  }),
  validations() {
    if (!this.hasDescription) {
      return {
        form: {
          siteStyle: {
            required,
          },
        },
      };
    }
    return {
      form: {
        siteStyle: {},
        siteOtherStyles: {
          required,
          minLength: minLength(3),
        },
      },
    };
  },
  methods: {
    otherHandler() {
      this.hasDescription = !this.hasDescription;

      if (!this.hasDescription) {
        this.form.siteOtherStyles = '';
      } else {
        setTimeout(() => {
          this.$refs.otherInput.focus();
        }, 100);
      }
    },
  },
};
</script>
